webpackJsonp([235],{

/***/ 1120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.7.9 released | VUX - Vue.js Mobile UI Component Framework", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1935:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1120),
  /* template */
  __webpack_require__(2081),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.7.9-138.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.7.9-138.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1f5b7c61", Component.options)
  } else {
    hotAPI.reload("data-v-1f5b7c61", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2081:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.7.9 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/clocker.html"
    }
  }, [_vm._v("Clocker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix bug when initial value is empty string #2449")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/panel.html"
    }
  }, [_vm._v("Panel")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] hide footer when footer.title is empty #2476")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/picker.html"
    }
  }, [_vm._v("Picker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix typo item_class => itemClass #2457")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/rater.html"
    }
  }, [_vm._v("Rater")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] prop:min add min value #2439")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-input.html"
    }
  }, [_vm._v("XInput")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] support china union 166 prefix phone number")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/bus.html"
    }
  }, [_vm._v("Bus")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] add bus to this.$vux")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f5b7c61", module.exports)
  }
}

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1935);

/***/ })

});


// WEBPACK FOOTER //
// 235.7a02b9e6.js